/**
 * Where the signup flow lives. Production signup links have always pointed at
 * the site root (`/?client_id=…`, `/?login`, `/?download=…`), so the flow's
 * entry is `/` and every signup page sits at `/<id>/`. Every signup path is
 * built from this value. The signup host's edge routing has its own copy of
 * the flow root per environment, and the two must agree.
 */
export const SIGNUP_FLOW_ROOT = '/';

/**
 * The Next route group holding every signup page. It gives those pages their
 * shared layout without adding a URL segment, and app-wide chrome steps aside
 * for it.
 */
export const SIGNUP_ROUTE_GROUP = '(signup)';

/**
 * The flow's old address. It only forwards to the root, so it draws no chrome
 * of its own either.
 */
export const SIGNUP_OLD_ENTRY_SEGMENT = 'signup';
